"use strict";
/**
 * Inventory Session Types
 *
 * Shared type definitions for inventory session items.
 * Used by both requests and responses.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_ACTIVITY_LABELS = void 0;
exports.inventoryLineKey = inventoryLineKey;
/**
 * What identifies a line of a count. GH546.
 *
 * 🚨 **A line is not identified by the article code.** An article with QVET lot control has **one
 * line per lot**, and they share code, description and warehouse — only the lot tells them apart.
 * Keying by code alone silently keeps one and drops the rest: measured on article 8493, whose three
 * lots in URBAN held 1, 3 and 47 units.
 *
 * It lives **here, in the contract**, because both sides need the same answer: the backend to match
 * uploads and reviews, the frontend to address the line a person is editing. Two copies of this rule
 * would drift, and the drift would be invisible — the same count landing on a different lot
 * depending on which side you asked.
 *
 * `noLot` is a marker and deliberately **not `0`**: QVET uses lot id `0` for "this lot does not
 * exist yet", so an article without lot control and a brand-new lot must not share a key.
 */
function inventoryLineKey(line) {
    const lot = line.lotId === undefined || line.lotId === null ? 'noLot' : String(line.lotId);
    return `${line.qvetCode}:${lot}`;
}
exports.SESSION_ACTIVITY_LABELS = {
    created: 'Sesión creada',
    uploaded: 'Conteo subido',
    reviewed: 'Revisión aplicada',
    downloaded: 'Hoja descargada',
    refreshed: 'Stock actualizado',
    exported: 'Hoja final exportada',
    sent_to_qvet: 'Conteo enviado a QVET',
    bulk_loss: 'Pérdidas aceptadas',
};
